import { Experiments } from 'constants/experiments'
import { useAppSelector } from 'hooks/reduxHooks'
import useExperiment from './useExperiment'

/**
 * Fires the `offer_region_bypass` experiment exposure event for users whose UTM matched a bypass
 * region filter rule (i.e. they are a candidate — `bypassRegionCandidateSettingId` is set).
 *
 * Exposure fires for BOTH control and variant so the exposed population is symmetric and the
 * 50/50 split holds on the analysed sample. The actual region-filter bypass behaviour is gated
 * separately (server `fetchRegionChannelSettings` + `regionChannelSettingsMiddleware`) on the
 * bucketed variation — this hook only records exposure, it does not change behaviour.
 *
 * Mounted once at the App root so it fires regardless of which page the matched user lands on.
 */
export default function useBypassRegionExperimentExposure() {
  const isCandidate = useAppSelector(state => !!state.marketing.bypassRegionCandidateSettingId)
  useExperiment(Experiments.growthOfferRegionBypass, { canActivate: isCandidate })
}
